

export enum SessionFormat {
  ONLINE = 'ONLINE',
  ONSITE = 'ONSITE'
};
